angular.module('impactx.indexqueue').controller('IndexQueueCtrl', [
    '$scope',
    'dataGen',
    'IndexQueueService',
    'TranslationService',
    'ToolbarService',
    'WebSocketService',
    IndexQueueCtrl]);

function IndexQueueCtrl($scope, dataGen, IndexQueueService, TranslationService, ToolbarService, WebSocketService) {
    var self = this;

    $scope.trns = {
        indexForeignCatalog: TranslationService.get('indexForeignCatalog'),
        currentTask: TranslationService.get('currentTask'),
        noCurrentTask: TranslationService.get('noCurrentTask'),
        queue: TranslationService.get('queue'),
        numberOfProducts: TranslationService.get('numberOfProducts'),
        indexTender: TranslationService.get('indexTender'),
        indexFull: TranslationService.get('indexFull'),
        indexMissingProducts: TranslationService.get('indexMissingProducts'),
        loading: TranslationService.get('loading'),
        contentUpdatesAutomatically: TranslationService.get('contentUpdatesAutomatically'),
        status: TranslationService.get('status'),
        startIndexing: TranslationService.get('startIndexing'),
        stopIndexing: TranslationService.get('stopIndexing'),
        creationTime: TranslationService.get('creationTime'),
        creationPos: TranslationService.get('creationPos'),
        startTime: TranslationService.get('startTime'),
        estEndTime: TranslationService.get('estEndTime'),
        estDuration: TranslationService.get('estDuration')
    };

    getData();

    IndexQueueService.init();
    self.getStatus = IndexQueueService.getStatus;
    self.getStatusMessage = IndexQueueService.getStatusMessage;
    self.isProgressing = IndexQueueService.isProgressing;
    self.isConnected = IndexQueueService.isConnected;
    self.hasError = IndexQueueService.hasError;

    self.applyChanges = function () {
        IndexQueueService.send({
            entries: $scope.entries
        });
    };

    self.sortableOptions = {
        stop: self.applyChanges,
        update: function (e, ui) {
            if (ui.item.sortable.model == "can't be moved") {
                ui.item.sortable.cancel();
            }
        },
        items: 'md-card:not(.not-sortable)'
    };

    $scope.$watch(function () {
            return IndexQueueService.getLastMessage();
        },
        function (newValue) {
            if (newValue) {
                $scope.$applyAsync(function () {
                    if (newValue.queue) {
                        $scope.currentTask = newValue.queue.currentTask;
                        $scope.entries = newValue.queue.entries;
                    }
                    if (newValue.status) {
                        $scope.isStopped = newValue.status.stopped;
                        $scope.statusReason = newValue.status.statusReason;
                    }
                });
            }
        });

    self.getLabelByIndexType = function (indexEntry) {
        if (indexEntry.isFullIndex) {
            return $scope.trns.indexFull;
        }
        else if (indexEntry.isMissingProductsIndex) {
            return $scope.trns.indexMissingProducts;
        }
        else if (indexEntry.isTender) {
            return $scope.trns.indexTender;
        }
        else {
            return $scope.trns.indexForeignCatalog;

        }
    };

    self.removeQueueEntry = function (entry) {
        var index = $scope.entries.indexOf(entry);

        if (index > -1) {
            $scope.entries.splice(index, 1);
            self.applyChanges();
        }
    };

    $scope.$on("$destroy", function () {
        IndexQueueService.close();
    });

    function getData() {
        var dataObj = {};
        dataGen.postAsForm({}, dataObj, "/index/status").then(function (data) {
            $scope.isStopped = impactX.isDefined(data, "data.stopped");
            $scope.statusReason = impactX.isDefined(data, "data.statusReason");
            $scope.trns.contentUpdateMessage = impactX.isDefined(data, "trns.contentUpdateMessage");
            $scope.trns.running = impactX.isDefined(data, "trns.running");
            $scope.trns.stopped = impactX.isDefined(data, "trns.stopped");
        });
   }

    self.startIndexing = function () {
        $scope.isStopped = false;
        var dataObj = {};
        return dataGen.postAsForm({}, dataObj, "/index/start").then(function (data) {
            $scope.isStopped = impactX.isDefined(data, "data.stopped");
            $scope.statusReason = impactX.isDefined(data, "data.statusReason");
        });
    };

     self.stopIndexing = function () {
        $scope.isStopped = true;
        var dataObj = {};
        return dataGen.postAsForm({}, dataObj, "/index/stop").then(function (data) {
            $scope.isStopped = impactX.isDefined(data, "data.stopped");
            $scope.statusReason = impactX.isDefined(data, "data.statusReason");
        });
    }

    self.isStopped = function () {
        return $scope.isStopped;
    }

    self.isNotStopped = function () {
        return !$scope.isStopped;
    }

   ToolbarService.setButtons([
        {
            label: $scope.trns.startIndexing,
            action: self.startIndexing,
            type: 'dialogaction',
            condition: self.isStopped,
            process: 'EditIndexQueue'
        },
        {
            label: $scope.trns.stopIndexing,
            action: self.stopIndexing,
            type: 'dialogaction',
            condition: self.isNotStopped,
            process: 'EditIndexQueue'
        }
    ]);
}
